import {RootState} from 'store'

import {OVERLAY_IDS} from './constants'
import {OverlayStateType} from './reducer'

const findOverlayById = (id: string, overlays: OverlayStateType) => {
  return overlays.find(overlay => overlay.id === id)
}

// @Todo dry this
export const getPreferencesVisibility = (state: RootState) => {
  return findOverlayById(OVERLAY_IDS.preferences, state.overlay)
}

export const getRoomDetailsOverlayVisibility = (state: RootState) => {
  return findOverlayById(OVERLAY_IDS.roomDetails, state.overlay)
}

export const getHotelGalleryOverlayVisibility = (state: RootState) => {
  return findOverlayById(OVERLAY_IDS.hotelGallery, state.overlay)
}
